import * as Phaser from "phaser-ce"
import { log } from "../../../common/Logging"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { PatientType } from "./DrTimeTypes"


export enum DrTimeAudio {
    LOBBY = "doctor-time-intro-1.mp3",
    HALLWAY_START = "doctor-time-intro-2.mp3",
    HALLWAY_SAW_PATIENT_VAPER = "doctor-time-hallway-saw-patient-1.mp3",
    HALLWAY_SAW_PATIENT_SMOKER = "doctor-time-hallway-saw-patient-2.mp3",
    CLICK_DOOR = "doctor-time-click-door.mp3",
    CLICK_ANOTHER_DOOR = "doctor-time-click-another-door.mp3",
    HALLWAY_DONE = "doctor-time-outro.mp3",

    TRY_AGAIN = "doctor-time-try-again.mp3",
    WRONG_TEST = "doctor-time-wrong-test.mp3"
}

export enum DrTimeImage {
    DR_HALLWAY = "doctorHallway.png",
    DR_RECEPTION = "doctorReception.png",
    PATIENT_VAPER = "patient1.png",
    PATIENT_SMOKER = "patient2.png",
    BG_HALLWAY = "hallway.png",
    BG_RECEPTION = "reception.png",
    BG_EXAM = "exam_room.png",
    CHECKMARK = "checkmark.png",
    CROSS = "cross.png",
    LUNGS_VAPING_1 = "lungs-vaping-1.png",
    LUNGS_VAPING_2 = "lungs-vaping-2.png",
    LUNGS_VAPING_3 = "lungs-vaping-3.png",
    LUNGS_VAPING_4 = "lungs-vaping-4.png",
    HEART_SMOKING_1 = "heart-smoking-1.png",
    HEART_SMOKING_2 = "heart-smoking-2.png",
    HEART_SMOKING_3 = "heart-smoking-3.png",
    HEART_SMOKING_4 = "heart-smoking-4.png",
    TEST_CAMERA = "test-camera.png",
    TEST_BLOODTEST = "test-bloodtest.png",
    TEST_XRAY = "test-xray.png",
    TEST_SCANNER = "test-scanner.png",
    TEST_EYEEXAM = "test-eyeexam.png"
}

export enum DrTimeTests {
    TEST_XRAY = "test-xray.png",
    TEST_CAMERA = "test-camera.png",
    TEST_SCANNER = "test-scanner.png",
    TEST_BLOODTEST = "test-bloodtest.png",
    TEST_EYEEXAM = "test-eyeexam.png"
}

export enum DrTimeAtlases {
    LOADING = "loading.json"
}

export enum ExamStep {
    ASK_SYMPTOMS = "ask-symptoms",
    PATIENT_RESPONSE_SYMPTOMS = "response-symptoms",
    ASK_TOBACCO = "ask-tobacco-use",
    PATIENT_RESPONSE_SMOKING_HISTORY = "response-smokinghistory",
    BLOOD = "blood",
    CAMERA = "camera",
    CHECK_CHART = "check-chart",
    CLICK_SYMPTOMS = "click-symptoms",
    DIAGNOSIS_1 = "diagnosis-1",
    DIAGNOSIS_2 = "diagnosis-2",
    DIAGNOSIS_3 = "diagnosis-3",
    EYE = "eye",
    FIVE_YEARS = "five-years",
    ONE_YEAR = "one-year",
    RECORD_HISTORY = "record-history",
    RUN_TEST = "run-test",
    SCANNER = "scanner",
    TEN_YEARS = "ten-years",
    THATS_RIGHT = "thats-right",
    THREE_YEARS = "three-years",
    XRAY = "xray",
}

export class DrTimeAssets {
    static findExamStepAudio = (examStep: ExamStep, patientType: PatientType) => {
        if (patientType === PatientType.VAPER && examStep === ExamStep.TEN_YEARS) {
            log.error(`Patient 1 doesn't have 10 year audio, use 1, 3 or 5 year`)
            return
        }
        if (patientType === PatientType.SMOKER && examStep === ExamStep.THREE_YEARS) {
            log.error(`Patient 2 doesn't have 3 year audio, use 1, 5, 10 year`)
            return
        }
        return `doctor-time-patient-${patientType}-${examStep}.mp3`
    }
}

export const loadAssets = (game: Phaser.Game) => {

    const load = PhaserUtils.makeLoader(game, "dr-time")
    load.autoLoad({imageEnum: DrTimeImage, audioEnum: DrTimeAudio, atlasEnum: DrTimeAtlases})

    const examSteps: Array<ExamStep> = Object.values(ExamStep)

    examSteps.forEach(examStep => {
        [PatientType.VAPER, PatientType.SMOKER].forEach(patientType => {
            if (patientType === PatientType.VAPER && examStep === ExamStep.TEN_YEARS) {
                return
            }
            if (patientType === PatientType.SMOKER && examStep === ExamStep.THREE_YEARS) {
                return
            }
            const name = DrTimeAssets.findExamStepAudio(examStep, patientType as PatientType)
            load.audio(name, name)
        })
    })
}

